import React from 'react';

const groups = [
  { label:'Frontend',    techs:['React.js','Next.js','Vue.js','TypeScript','Tailwind','Bootstrap'] },
  { label:'Backend',     techs:['Node.js','Express','Spring Boot','Django','FastAPI','Laravel'] },
  { label:'Mobile',      techs:['Flutter','React Native','Swift','Kotlin','Dart','Firebase'] },
  { label:'Database',    techs:['MongoDB','PostgreSQL','MySQL','Redis','Elasticsearch','Supabase'] },
  { label:'Cloud/DevOps',techs:['AWS','GCP','Docker','Kubernetes','CI/CD','Terraform'] },
  { label:'Security',    techs:['Burp Suite','Metasploit','Wireshark','Nmap','OWASP','Kali Linux'] },
];

const TechStack = () => (
  <section className="section-pad" style={{ background:'var(--bg)' }}>
    <div className="container">
      <div className="row align-items-end mb-5">
        <div className="col-lg-5">
          <span className="section-label">Technologies</span>
          <h2 className="section-title">Our Tech<br/><em>Arsenal</em></h2>
        </div>
        <div className="col-lg-7">
          <p className="section-sub" style={{ maxWidth:500 }}>We select technologies with the same care an architect selects materials — for their longevity, performance, and fitness for purpose.</p>
        </div>
      </div>

      <div className="row g-0" style={{ border:'1px solid var(--border)' }}>
        {groups.map((g, i) => (
          <div key={i} className="col-lg-4 col-md-6" style={{
            borderRight: i%3===2 ? 'none':'1px solid var(--border)',
            borderBottom: i<3 ? '1px solid var(--border)':'none',
            padding:'32px 28px',
          }}>
            <span style={{ fontFamily:'var(--font-body)', fontSize:'0.65rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan)', display:'block', marginBottom:18 }}>{g.label}</span>
            <div>{g.techs.map(t => <span key={t} className="tech-pill">{t}</span>)}</div>
          </div>
        ))}
      </div>

      {/* Stats strip */}
      <div className="row g-0 mt-5" style={{ border:'1px solid var(--border)' }}>
        {[['250+','Projects Delivered'],['150+','Happy Clients'],['40+','Expert Developers'],['20+','Countries Served']].map(([n,l],i) => (
          <div key={i} className="col-6 col-md-3 text-center" style={{ padding:'40px 20px', borderRight: i<3 ? '1px solid var(--border)' : 'none' }}>
            <div className="stat-num">{n}</div>
            <div className="stat-label">{l}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TechStack;
